import { Redirect, Route, Switch } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { billingRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {billingRoutes.map((prop, key) => {
      if (prop.layout === 'billing') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/billing" to="/billing/listing" />
  </Switch>
);

const Billing = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Billing;
